import { useContext } from "react";
import AccessControlContext from "../context/AccessControlProvider";

const useAccessControl = () => {
    return useContext(AccessControlContext);
}

export default useAccessControl;